"use strict";

import { changeURL, initStateFromUrl } from "./customFunctions/paramsURL";

export const BACKGROUND_COLOR = 0xffffff;
export const ENVIRONMENT_MAP = "public/environment/garden_2k.hdr";
export const ENVIRONMENT_MAP_INTENSITY = 5;
export const SHADOW_TRANSPARENCY = 0.1;
export const TONE_MAPPING_EXPOSURE = 1.5;

export const log = false;
export let pdfImg = { img: "" };
export let pdfImgTop = { img: "" };

//#region URL AND STATE
let isBatchUpdating = false;
const delay = 100;

function triggerCallback() {
  if (isBatchUpdating) {
    return;
  }

  isBatchUpdating = true;

  setTimeout(() => {
    changeURL();
    isBatchUpdating = false;
  }, delay);
}

function createNestedProxy(target) {
  return new Proxy(target, {
    set(target, key, value) {
      target[key] = value;

      triggerCallback();

      return true;
    },

    get(target, key) {
      const value = target[key];
      if (typeof value === "object" && value !== null) {
        if (value instanceof Set) {
          return createSetProxy(value); // STATE PARAM === SET
        } else if (Array.isArray(value)) {
          return createArrayProxy(value); // STATE PARAM === ARRAY
        } else {
          return createNestedProxy(value); // STATE PARAM === ...
        }
      }
      return value;
    },
  });
}

function createSetProxy(set) {
  //DESCRIPTION OWN METHOD FOR PROXY COVER
  return new Proxy(set, {
    get(target, prop) {
      if (prop === "add") {
        return (value) => {
          target.add(value);
          triggerCallback();
          return target;
        };
      }

      if (prop === "delete") {
        return (value) => {
          const result = target.delete(value);
          triggerCallback();
          return result;
        };
      }

      if (prop === "clear") {
        return () => {
          target.clear();
          triggerCallback();
        };
      }

      if (prop === "has") {
        return (value) => {
          const result = target.has(value);
          triggerCallback();
          return result;
        };
      }

      if (prop === "forEach") {
        return (...args) => {
          target.forEach(...args);
          triggerCallback();
        };
      }

      if (prop === "from") {
        return (iterable) => {
          const newSet = Set.from(iterable);
          triggerCallback();
          return newSet;
        };
      }

      // if (prop === "values") {
      //   return () => {
      //     const result = Set.prototype.values.call(target);
      //     triggerCallback();
      //     return result;
      //   };
      // }

      if (prop === "values" || prop === Symbol.iterator) {
        return () => {
          const iterator = target[Symbol.iterator](); // Використовуємо стандартний ітератор
          triggerCallback();
          return iterator;
        };
      }

      return target[prop];
    },

    set(target, prop, value) {
      target[prop] = value;
      triggerCallback();
      return true;
    },
  });
}

function createArrayProxy(array) {
  return new Proxy(array, {
    set(target, key, value) {
      target[key] = value;

      triggerCallback();

      return true;
    },
    get(target, key) {
      if (
        key === "push" ||
        key === "pop" ||
        key === "shift" ||
        key === "unshift" ||
        key === "splice" ||
        key === "filter"
      ) {
        return (...args) => {
          const result = Array.prototype[key].apply(target, args);
          triggerCallback();
          return result;
        };
      }
      return target[key];
    },
  });
}


export const SIZE_DATA = {
  0: [ // Straight walls
    { code: "R204H", width: 2.32, length: 2.98, price: 1999 },
    { code: "R205H", width: 2.32, length: 3.71, price: 2299 },
    { code: "R305H", width: 3.06, length: 3.71, price: 2499 },
    { code: "R306H", width: 3.06, length: 4.45, price: 2699 },
    { code: "R308H", width: 3.06, length: 5.93, price: 3299 },
  ],
  1: [ // Sloping walls 
    { code: "S104H", width: 3.06, length: 2.98, price: 2299 },
    { code: "S106H", width: 3.06, length: 4.45, price: 2849 },
    { code: "S206H", width: 3.80, length: 4.45, price: 3099 },
    { code: "S208H", width: 3.80, length: 5.93, price: 3699 },
  ],
  2: [ // Extra high
    { code: "R306XH", width: 3.06, length: 4.45, price: 3699 },
    { code: "R308XH", width: 3.06, length: 5.93, price: 4299 },
  ],
};

export const COLORS_DATA = [
  { name: "Aluminum", hex: "#C8C8C8", ral: null, base: true, img: "public/img/colors/marevo-color-aluminum.png" },
  { name: "Black", hex: "#000000", ral: null, base: true },
  { name: "Custom", hex: null, ral: null, base: true, custom: true, surcharge: 400, img: "public/img/colors/marevo-color-custom.png" },
  { name: "Gris Anthracite", hex: "#16303B", ral: "7016" },
  { name: "Roseau Vert", hex: "#576147", ral: "6013" },
  { name: "Vert Olive", hex: "#3A4A34", ral: "6003" },
  { name: "Vert Spin", hex: "#072914", ral: "6009" },
  { name: "Gris Quartz", hex: "#62625A", ral: "7039" },
  { name: "Mauve Rouge", hex: "#780E2C", ral: "3004" },
  { name: "Rouge Carmin", hex: "#AB161A", ral: "3002" },
  { name: "Blanc Pur", hex: "#FFFFF7", ral: "9010" },
  { name: "Vert Pale", hex: "#739D7A", ral: "6021" },
  { name: "Noir Gris", hex: "#221E20", ral: "7021" },
  { name: "Bleu Pastel", hex: "#4E8CB1", ral: "5024" },
  { name: "Rouge Signal", hex: "#B72125", ral: "3001" },
];

export const ACCESSORIES_DATA = [
  {
    id: "ventilation",
    title: "Ventilation",
    items: [
      { key: "automateOpening", name: "Automated opening", price: 49, img: "public/img/accessories/marevo-acc-automate-opening.png", meshKey: ["r_L_Win_auto", "r_R_Win_auto"], typeGroup: "accessoriesType", typeKey: "automateOpening" },
      { key: "mosquitoDoor", name: "Mosquito door", price: 169, img: "public/img/accessories/marevo-acc-mosquito-door.png", meshKey: "mosquito_door", typeGroup: "accessoriesType", typeKey: "mosquitoDoor" },
      { key: "extraDoor", name: "Extra single door", price: 169, img: "public/img/accessories/marevo-acc-extra-door.png", meshKey: "extra_door", typeGroup: "accessoriesType", typeKey: "extraDoor" },
      { key: "extraDoubleDoor", name: "Extra single door for double opening", price: 169, img: "public/img/accessories/marevo-acc-extra-double-door.png", meshKey: ["front_wall_double", "back_wall_double_door"], typeGroup: "accessoriesType", typeKey: "extraDoubleDoor" },
      { key: "roofWindow", name: "Extra roof window", price: 109, img: "public/img/accessories/marevo-acc-roof-window.png", meshKey: ["r_L_Win_manual", "r_R_Win_manual"], typeGroup: "accessoriesType", typeKey: "roofWindow" },
      { key: "sideWindow", name: "Side window", price: [169, 218], img: "public/img/accessories/marevo-acc-side-window.png", meshKey: "side_window", typeGroup: "accessoriesType", typeKey: "sideWindow" },
      { key: "backWindow", name: "Back window", price: [169, 218], img: "public/img/accessories/marevo-acc-back-window.jpg", meshKey: "back_window", typeGroup: "accessoriesType", typeKey: "backWindow" },
      { key: "standHeater", name: "Palma Heating", price: 189, img: "public/img/accessories/marevo-acc-palma-heater.png", meshKey: "palma_heater", typeGroup: "accessoriesType", typeKey: "palmaHeating" },
      { key: "phoenixHeater", name: "Phoenix Heating", price: 349, img: "public/img/accessories/marevo-acc-phoenix-heater.png", meshKey: "phoenix_heater", typeGroup: "accessoriesType", typeKey: "phoenixHeating" },
    ],
  },
  {
    id: "organization",
    title: "Organization",
    items: [
      { key: "woodTable1Win", name: "Wood work table 1 window", price: 89, img: "public/img/accessories/marevo-acc-wood-table-1win.png", meshKey: ["R_table_1_wood-pl", "S_table_1_wood-pl"], typeGroup: "organizationType", typeKey: "woodTable1Win" },
      { key: "woodTable3Win", name: "Wood work table 3 windows", price: 169, img: "public/img/accessories/marevo-acc-wood-table-3win.png", meshKey: ["R_table_3_wood-pl", "S_table_3_wood-pl"], typeGroup: "organizationType", typeKey: "woodTable3Win" },
      { key: "woodShelf1Win", name: "Wood work shelf 1 window", price: 69, img: "public/img/accessories/marevo-acc-wood-shelf-1win.png", meshKey: ["R_shelf_1_wood-pl", "S_shelf_1_wood-pl"], typeGroup: "organizationType", typeKey: "woodShelf1Win" },
      { key: "woodShelf3Win", name: "Wood work shelf 3 windows", price: 129, img: "public/img/accessories/marevo-acc-wood-shelf-3win.png", meshKey: ["R_shelf_3_wood-pl", "S_shelf_3_wood-pl"], typeGroup: "organizationType", typeKey: "woodShelf3Win" },
      { key: "plasticTable1Win", name: "Plastic work table 1 window", price: 69, img: "public/img/accessories/marevo-acc-plastic-table-1win.png", meshKey: ["R_table_1_wood-pl", "S_table_1_wood-pl"], typeGroup: "organizationType", typeKey: "plasticTable1Win" },
      { key: "plasticTable3Win", name: "Plastic work table 3 windows", price: 119, img: "public/img/accessories/marevo-acc-plastic-table-3win.png", meshKey: ["R_table_3_wood-pl", "S_table_3_wood-pl"], typeGroup: "organizationType", typeKey: "plasticTable3Win" },
      { key: "plasticShelf1Win", name: "Plastic work shelf 1 window", price: 49, img: "public/img/accessories/marevo-acc-plastic-shelf-1win.png", meshKey: ["R_shelf_1_wood-pl", "S_shelf_1_wood-pl"], typeGroup: "organizationType", typeKey: "plasticShelf1Win" },
      { key: "plasticShelf3Win", name: "Plastic work shelf 3 windows", price: 89, img: "public/img/accessories/marevo-acc-plastic-shelf-3win.png", meshKey: ["R_shelf_3_wood-pl", "S_shelf_3_wood-pl"], typeGroup: "organizationType", typeKey: "plasticShelf3Win" },
      { key: "cultivationTable3Win", name: "Cultivation table 3 windows", price: 159, img: "public/img/accessories/marevo-acc-cultivation-table-3win.jpg", meshKey: ["R_table_de_culture_3", "S_table_de_culture_3"], typeGroup: "organizationType", typeKey: "cultivationTable3Win" },
      { key: "aluminumTable2Win", name: "Aluminum table 2 windows", price: 159, img: "public/img/accessories/marevo-acc-alumin-table-2win.png", meshKey: ["R_table_2_alum", "S_table_2_alum"], typeGroup: "organizationType", typeKey: "aluminumTable2Win" },
      { key: "aluminumShelf2Win", name: "Aluminum shelf 2 windows", price: 159, img: "public/img/accessories/marevo-acc-alumin-shelf-2win.jpg", meshKey: ["R_shelf_2_alum", "S_shelf_2_alum"], typeGroup: "organizationType", typeKey: "aluminumShelf2Win" },
      { key: "set2Shelves", name: "Set of 2 small shelves", price: 69, img: "public/img/accessories/marevo-acc-set-shelves.png", meshKey: ["R_shelf_set", "S_shelf_set"], typeGroup: "organizationType", typeKey: "set2Shelves" },
    ],
  },
  {
    id: "other",
    title: "Other",
    items: [
      { key: "veil", name: "Shade veil", price: 89, img: "public/img/accessories/marevo-acc-veil.png", meshKey: "shade_veil", typeGroup: "option", typeKey: "veil" },
      { key: "downpipes", name: "Downpipes", price: 49, img: "public/img/accessories/marevo-acc-downpipes.png", meshKey: "downpipes", typeGroup: "option", typeKey: "downpipes" },
      { key: "roofDecor", name: "Roof decoration", price: 69, img: "public/img/accessories/marevo-acc-roof-decor.png", meshKey: "roof_decor", typeGroup: "option", typeKey: "roofDecor" },
    ],
  },
  {
    id: "paquets",
    title: "Paquets of accessories",
    items: [
      { key: "paquetVentilation", name: "Ventilation paquet", price: 399, img: "public/img/accessories/marevo-acc-paquet-ventilation.png", meshKey: null, typeGroup: "accessoriesPaquetsType", typeKey: "ventilation" },
      { key: "paquetCultivation", name: "Cultivation paquet", price: 349, img: "public/img/accessories/marevo-acc-paquet-cultivation.png", meshKey: null, typeGroup: "accessoriesPaquetsType", typeKey: "cultivation" },
    ],
  },
];

export const PRODUCT_URLS = [
  {
    title: "aluminum-models",
    links: [
      { name: "R204H", link: "https://ma-serre-en-verre.shop/collections/modeles-daction/products/droite-r204.xml" },
      { name: "R205H", link: "https://ma-serre-en-verre.shop/collections/modeles-daction/products/serre-acd-r205h-aluline.xml" },
      { name: "R305H", link: "https://ma-serre-en-verre.shop/collections/modeles-daction/products/droite-r305.xml" },
      { name: "R306H", link: "https://ma-serre-en-verre.shop/collections/modeles-daction/products/serre-acd-r306h-aluline.xml" },
      { name: "R308H", link: "https://ma-serre-en-verre.shop/collections/modeles-daction/products/serre-acd-r308h-aluline.xml" },
      { name: "S104H", link: "https://ma-serre-en-verre.shop/collections/modeles-daction/products/oblique-s104.xml" },
      { name: "S106H", link: "https://ma-serre-en-verre.shop/collections/modeles-daction/products/oblique-s106.xml" },
      { name: "S206H", link: "https://ma-serre-en-verre.shop/collections/modeles-daction/products/serre-oblique-acd-s206h.xml" },
      { name: "S208H", link: "https://ma-serre-en-verre.shop/collections/modeles-daction/products/serre-acd-r205h-aluline.xml" },
    ]
  },
  {
    title: "black-models",
    links: [
      { name: "R204H", link: "https://ma-serre-en-verre.shop/collections/serres-acd-blackline/products/serre-acd-r204-blackline.xml" },
      { name: "R205H", link: "https://ma-serre-en-verre.shop/collections/serres-acd-blackline/products/retro-r205.xml" },
      { name: "R305H", link: "https://ma-serre-en-verre.shop/collections/serres-acd-blackline/products/serre-acd-r305-blackline-11-35-m.xml" },
      { name: "R306H", link: "https://ma-serre-en-verre.shop/collections/serres-acd-blackline/products/retro-r306.xml" },
      { name: "R308H", link: "https://ma-serre-en-verre.shop/collections/serres-acd-blackline/products/serre-acd-r308h-blackline.xml" },
      { name: "S104H", link: "https://ma-serre-en-verre.shop/collections/serres-acd-blackline/products/serre-acd-s104-blackline-9-12-m.xml" },
      { name: "S106H", link: "https://ma-serre-en-verre.shop/collections/serres-acd-blackline/products/serre-acd-s106-blackline-13-62-m.xml" },
      { name: "S206H", link: "https://ma-serre-en-verre.shop/collections/serres-acd-blackline/products/serre-acd-s206h-blackline-3-80-x-4-45m-16-91-m.xml" },
      { name: "S208H", link: "https://ma-serre-en-verre.shop/collections/serres-acd-blackline/products/serre-acd-s208-blackline-22-53-m-1.xml" },
      { name: "R306XH", link: "https://ma-serre-en-verre.shop/collections/serres-acd-blackline/products/retro-r306-extra-haute-13-62m.xml" },
      { name: "R308XH", link: "https://ma-serre-en-verre.shop/collections/serres-acd-blackline/products/serre-haute-acd-r308xh-blackline.xml" },
    ]
  },
  {
    title: "accessories",
    links: [
      { name: "automateOpening", link: "https://ma-serre-en-verre.shop/collections/accessoires-serre-jardin-acd/products/ouverture-automatique.xml" },
      { name: "mosquitoDoor", link: "https://ma-serre-en-verre.shop/collections/accessoires-serre-jardin-acd/products/porte-moustiquaire.xml" },
      { name: "extraDoor", link: "https://ma-serre-en-verre.shop/collections/accessoires-serre-jardin-acd/products/porte-supplementaire-arriere.xml" },
      { name: "extraDoubleDoor", link: "https://ma-serre-en-verre.shop/collections/accessoires-serre-jardin-acd/products/porte-supplementaire-pour-ouverture-double-sur-facade-alu.xml" },
      { name: "sideWindow", link: "https://ma-serre-en-verre.shop/collections/accessoires-serre-jardin-acd/products/lucarne-louvre-serre-acd.xml" },
      { name: "backWindow", link: "https://ma-serre-en-verre.shop/collections/accessoires-serre-jardin-acd/products/lucarne-louvre-serre-acd.xml" },
      { name: "standHeater", link: "https://ma-serre-en-verre.shop/products/chauffage-palma.xml" },
      { name: "phoenixHeater", link: "https://ma-serre-en-verre.shop/products/chauffage-phoenix.xml" },
      { name: "woodTable1Win", link: "https://ma-serre-en-verre.shop/products/petite-table-bois-serre-acd.xml" },
      { name: "woodTable3Win", link: "https://ma-serre-en-verre.shop/collections/accessoires-serre-jardin-acd/products/table-universelle-avec-bois.xml" },
      { name: "woodShelf1Win", link: "https://ma-serre-en-verre.shop/collections/accessoires-serre-jardin-acd/products/petite-etagere-bois-serre-acd.xml" },
      { name: "woodShelf3Win", link: "https://ma-serre-en-verre.shop/products/etagere-universelle-avec-bois.xml" },
      { name: "plasticTable1Win", link: "https://ma-serre-en-verre.shop/products/petite-table-travail-universelle.xml" },
      { name: "plasticTable3Win", link: "https://ma-serre-en-verre.shop/products/table-de-travail-universelle.xml" },
      { name: "plasticShelf1Win", link: "https://ma-serre-en-verre.shop/products/petite-etagere-pour-serre.xml" },
      { name: "plasticShelf3Win", link: "https://ma-serre-en-verre.shop/products/etagere-universelle.xml" },
      { name: "cultivationTable3Win", link: "https://ma-serre-en-verre.shop/products/table-de-culture.xml" },
      { name: "aluminumTable2Win", link: "https://ma-serre-en-verre.shop/products/table-aluminium-noir-serre-acd.xml" },
      { name: "aluminumShelf2Win", link: "https://ma-serre-en-verre.shop/products/etagere-serre-aluminium-noir.xml" },
      { name: "set2Shelves", link: "https://ma-serre-en-verre.shop/products/set-de-2-etageres-en-aluminium.xml" },
      { name: "veil", link: "https://ma-serre-en-verre.shop/collections/accessoires-serre-jardin-acd/products/toile-dombrage-professionnelle.xml" },
      { name: "downpipes", link: "https://ma-serre-en-verre.shop/products/set-de-2-descentes-deau.xml" },
      { name: "roofDecor", link: "https://ma-serre-en-verre.shop/products/decoration-faitieres.xml" },
      { name: "paquetVentilation", link: "https://ma-serre-en-verre.shop/products/paquet-ventilation-maj-2021.xml" },
      { name: "paquetCultivation", link: "https://ma-serre-en-verre.shop/products/paquet-culture-serre.xml" },
    ]
  },
]


export const INSTALLATION_PRICE = 851;
export const ANCHORING_SERVICE_PRICE = 75;

export const stateForProxy = {
  countryType: 0,
  shapeType: 0,
  sizeIndex: 0,
  height: 2,
  length: 2,
  width: 4,
  installation: false,
  anchorType: 'ground',
  colorBody: "#C8C8C8",
  // Set of selected accessory keys (from ACCESSORIES_DATA item.key)
  subAccessoriesUrl: new Set(['downpipes']),
  subSystemUrl: new Set(),
  electro: new Set(),
  // persisted [{key, zone, span, slope}]
  accessoryPlacements: [],
  // 'manual-window' | 'auto-window' per window accessory
  windowModes: { sideWindow: 'manual-window', backWindow: 'manual-window' },
  // downpipes material: 'grey_plastic' | 'black_plastic' | 'black_alum'
  downpipeMaterial: 'grey_plastic',
  price: 0
};

export const state = new Proxy(stateForProxy, {
  get(target, key) {
    const value = target[key];
    if (key === "currentActiveSystems") {
      // console.log(value);
    }
    if (typeof value === "object" && value !== null) {
      if (value instanceof Set) {
        return createSetProxy(value); // COVER FOR SET
      } else if (Array.isArray(value)) {
        return createArrayProxy(value); // COVER FOR ARRAY
      } else {
        return createNestedProxy(value); // COVER FOR ANOTHER ...
      }
    }
    return value;
  },

  set(target, key, value) {
    target[key] = value;

    triggerCallback();

    return true;
  },
});

window.state = state;

await initStateFromUrl();
//#endregion

export const MODEL_PATHS = ["public/models/Ma_Serre_R200H.glb", "public/models/Ma_Serre_R300H.glb", "public/models/Ma_Serre_S100H.glb", "public/models/Ma_Serre_S200H.glb", "public/models/Ma_Serre_R300HX.glb"];
export const MODEL_CENTER_POSITION = 0;

export function getInitialModelIndex() {
  const shapeType = +state.shapeType;
  const sizeIndex = +state.sizeIndex;
  if (shapeType === 2) return MODEL_PATHS.length - 1;
  const sizes = SIZE_DATA[shapeType];
  const code = sizes?.[sizeIndex]?.code ?? sizes?.[0]?.code ?? '';
  const digit = parseInt(code[1], 10);
  if (shapeType === 0) return digit === 2 ? 0 : 1;
  return digit === 1 ? 2 : 3;
}



console.log(state);
